import { Reducer } from 'redux'
import {
  TemplateCreationActionTypes,
  type TemplateCreationAction,
  type TemplateInCreation,
  initialTemplateInCreationState,
} from './types'

export * from './types'

export const reducer: Reducer<TemplateInCreation, TemplateCreationAction> = (
  state = initialTemplateInCreationState,
  action
) => {
  switch (action.type) {
    case TemplateCreationActionTypes.SET_CREATE_TEMPLATE_DATA: {
      return {
        ...state,
        integrationData: {
          ...state.integrationData,
          ...action.payload,
        },
      }
    }
    case TemplateCreationActionTypes.CLEAR_CURRENT_TEMPLATE_DATA:
      return initialTemplateInCreationState

    default: {
      return state
    }
  }
}
